/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Analyze_Allocations_MonthInputs */

const en_admin_analyze_allocations_month = /** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month`)
};

const de_admin_analyze_allocations_month = /** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

const es_admin_analyze_allocations_month = /** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes`)
};

const fr_admin_analyze_allocations_month = /** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mois`)
};

const nl_admin_analyze_allocations_month = /** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maand`)
};

/** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */
const it_admin_analyze_allocations_month = en_admin_analyze_allocations_month;

/** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */
const pt_br2_admin_analyze_allocations_month = en_admin_analyze_allocations_month;

/** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */
const pl_admin_analyze_allocations_month = en_admin_analyze_allocations_month;

/** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */
const hu_admin_analyze_allocations_month = en_admin_analyze_allocations_month;

/** @type {(inputs: Admin_Analyze_Allocations_MonthInputs) => LocalizedString} */
const ro_admin_analyze_allocations_month = en_admin_analyze_allocations_month;

/**
* | output |
* | --- |
* | "Month" |
*
* @param {Admin_Analyze_Allocations_MonthInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_analyze_allocations_month = /** @type {((inputs?: Admin_Analyze_Allocations_MonthInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Analyze_Allocations_MonthInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_analyze_allocations_month(inputs)
	if (locale === "de") return de_admin_analyze_allocations_month(inputs)
	if (locale === "es") return es_admin_analyze_allocations_month(inputs)
	if (locale === "fr") return fr_admin_analyze_allocations_month(inputs)
	if (locale === "nl") return nl_admin_analyze_allocations_month(inputs)
	if (locale === "it") return it_admin_analyze_allocations_month(inputs)
	if (locale === "pt-BR") return pt_br2_admin_analyze_allocations_month(inputs)
	if (locale === "pl") return pl_admin_analyze_allocations_month(inputs)
	if (locale === "hu") return hu_admin_analyze_allocations_month(inputs)
	return ro_admin_analyze_allocations_month(inputs)
});
export { admin_analyze_allocations_month as "admin.analyze.allocations.month" }